var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.361 3.5a.86.86 0 0 0-.861.861V15.64a.86.86 0 0 0 .861.861h3.222a.75.75 0 0 1 0 1.5H4.361A2.36 2.36 0 0 1 2 15.639V4.36A2.36 2.36 0 0 1 4.361 2h3.222a.75.75 0 1 1 0 1.5zm8.33 1.942a.75.75 0 0 1 1.062 0L17.78 9.47a.747.747 0 0 1 0 1.06l-4.027 4.028a.75.75 0 0 1-1.061-1.06l2.747-2.748H7.583a.75.75 0 0 1 0-1.5h7.856l-2.747-2.747a.75.75 0 0 1 0-1.061",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;